import { Box, Button, FormLabel, FormGroup } from '@mui/material';
import { Formik } from 'formik';
import { FC, useState, useEffect } from 'react';
import * as yup from 'yup';

type ThumbProps = {
  file: File | null;
  src?: string;
  onChange?: (src: string) => void;
};

export const Thumb: FC<ThumbProps> = ({ file, src, onChange }) => {
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const reader = new FileReader();
    if (file) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        const result = reader.result as string;
        if (onChange !== undefined) onChange(result);
      };
      setLoading(false);
    }
  }, [file]);

  if (!file) {
    return null;
  }

  if (loading) {
    return <p>読み込み中….</p>;
  }

  return (
    <Box
      component="img"
      src={src ? src : '/logo512.png'}
      alt={file.name}
      className="img-thumbnail mt-2"
      sx={{ maxHeight: 200, objectFit: 'contain' }}
    />
  );
};

type Props = {
  id?: string;
  src?: string;
  onChange?: (src: string) => void;
};

export const ImageUploader: FC<Props> = (props: Props) => {
  return (
    <Formik
      id={props.id}
      initialValues={{ file: null }}
      onSubmit={(values: any) => {
        alert(
          JSON.stringify({
            fileName: values.file.name,
            type: values.file.type,
            size: `${values.file.size} bytes`,
          })
        );
      }}
      validationSchema={yup.object().shape({
        file: yup.mixed().required(),
      })}
    >
      {({ handleSubmit, setFieldValue, values }) => {
        return (
          <form onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel htmlFor="file">ファイルをアップロード</FormLabel>
              <Button variant="contained" component="label">
                <input
                  hidden
                  type="file"
                  id="file"
                  name="file"
                  onChange={(event) => {
                    setFieldValue(
                      'file',
                      event.currentTarget.files !== null
                        ? event.currentTarget.files[0]
                        : null
                    );
                  }}
                  accept="image/jpeg"
                  className="form-control"
                />
                ファイルを選択
              </Button>
              <Box mt={2}>
                <Thumb
                  src={props.src}
                  file={values.file}
                  onChange={props.onChange}
                />
              </Box>
            </FormGroup>
          </form>
        );
      }}
    </Formik>
  );
};
